import { ModuleWithProviders, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AuthComponent } from './auth.component';
import { AuthService } from './auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    AuthComponent
  ],
  exports: [
    AuthComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AuthModule {
  static forRoot(environment: any): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        { provide: 'environment', useValue: environment }
      ]
    };
  }
}
